<template>
  <div>
    <v-tabs v-model="active" color="transparent" slider-color="red lighten-3">
      <v-tab>Prodotti</v-tab>
      <v-tab-item :lazy="true" style="margin-top:10px">
        <v-data-table :items="products" :headers="Headers">
          <template slot="items" slot-scope="props">
            <tr style="max-height:100px;overflow:hidden;cursor:pointer">
              <td>
                  <v-img :src="props.foto" aspect-ratio="1" height="50px" width="50px" contain></v-img>
              </td>

              <td class="text-xs-left">{{props.title}}</td>
              <td class="text-xs-left">{{props.desc}}</td>
              <td>
                <v-btn class="q-orange" flat @click="removePrice(props.id)">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-tab-item>
      <v-tab>Ordini</v-tab>
      <v-tab-item :lazy="true" style="margin-top:10px">bbb</v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import ajax from "../../ajax.js";
import Editor from "@tinymce/tinymce-vue";

export default {
  name: "Ecommerce",
  mounted: function() {},
  components: {
    editor: Editor,
  },
  computed: {
    Headers: function () {
            
                let result = [
                    this.getString('Foto'),
                    this.getString('Titolo'),
                    this.getString('Descrizione'),
                ]
                return result
            
        },
  },
  data: () => {
    return {
      loading: false,
      active: 0,
      products: [
        {
          id: 1,
          title: "prodotto1",
          desc: "blablabla",
          foto:
            "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&w=1000&q=80"
        },
        {
          id: 2,
          title: "prodotto2",
          desc: "blablabl2",
          foto:
            "https://images.unsplash.com/photo-1516026672322-bc52d61a55d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&w=1000&q=80"
        }
      ]
    };
  },
  methods: {
    getString: function(key, values) {
      return this.$store.state.currentTranslator.getString(key, values);
    },
    removePrice: function(item) {
      let self = this;
      if (self.shopID > 0) {
        ajax.axios
          .delete(
            ajax.baseUrl() +
              "/admin/shops/shop/" +
              self.shopID +
              "/prices/" +
              item.idPrice,
            {
              headers: self.$store.getters.tokenHeader,
              withCredentials: true
            }
          )
          .then(function(response) {
            ajax.validateToken(response.headers, self.$store);
            self.$emit(
              "siteAlertSuccess",
              self.getString("Servizio eliminato.")
            );
            self.prices = response.data.data.prices;
          })
          .catch(function(error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
          });
      }
    }
  }
};
</script>

<style scoped>
.products {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 400px;
  text-align: left;
}
.products span {
  flex-grow: 1;
  padding: 10px;
}

.products .desc {
  flex-grow: 3;
  width: 80%;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/backend/Ecommerce.vue